import { ButtonProps, Checkbox, FormControlLabel, Grid, SxProps } from '@mui/material'
import React from 'react'

interface MultiSelectButtonGroupProps extends ButtonProps {
  buttonGroup: string[] | { name: string; key: string }[]
  selectedButtons?: string[] // Changed from selectedButton to selectedButtons array
  setSelectedButtons: (selectedButtons: string[]) => void // Changed from setSelectedButton
  title?: string
  sx?: SxProps
  readOnly?: boolean
  disabled?: boolean
  required?: boolean
}

export const EdifyMultiSelectButtonGroupAlt: React.FC<MultiSelectButtonGroupProps> = ({
  setSelectedButtons,
  buttonGroup,
  selectedButtons = [],
  readOnly,
  disabled,
  required,
}) => {
  const group: { name: string; key: string }[] = buttonGroup.map(b => {
    if (typeof b === 'string') {
      return { name: b, key: b }
    }
    return b
  })

  const handleButtonClick = (buttonKey: string) => {
    if (readOnly || disabled) return

    const isSelected = selectedButtons.includes(buttonKey)

    if (isSelected) {
      setSelectedButtons(selectedButtons.filter(btn => btn !== buttonKey))
    } else {
      setSelectedButtons([...selectedButtons, buttonKey])
    }
  }

  const isButtonSelected = (buttonKey: string) => {
    return selectedButtons.includes(buttonKey)
  }

  return (
    <Grid container gap='8px' spacing={2} sx={{ marginTop: '8px' }}>
      {group.map((button, i) => {
        const buttonKey = button.key
        const isSelected = isButtonSelected(buttonKey)
        return (
          <FormControlLabel
            required={required}
            key={`button-${buttonKey}-${i}`}
            control={
              <Checkbox
                checked={isSelected}
                readOnly={readOnly}
                disabled={disabled}
                onChange={() => handleButtonClick(buttonKey)}
              />
            }
            label={button.name}
          />
        )
      })}
    </Grid>
  )
}
